import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionValueFieldPath = () => {
  const condition = useConditionFieldPath();
  return `${condition}.value` as const;
};
